export const REQUEST_ORGANIZATIONS = "REQUEST_ORGANIZATIONS";
export const RECEIVE_ORGANIZATIONS = "RECEIVE_ORGANIZATIONS";
export const SELECT_ORGANIZATION = "SELECT_ORGANIZATION";
export const CLEAN_ORGANIZATIONS = "CLEAN_ORGANIZATIONS";
export const REQUEST_CURRENT_ORGANIZATION = "REQUEST_CURRENT_ORGANIZATION";
export const RECEIVE_CURRENT_ORGANIZATION = "RECEIVE_CURRENT_ORGANIZATION";
export const REQUEST_CURRENT_ORG_FAILED = "REQUEST_CURRENT_ORG_FAILED";

export function requestOrganizations() {
  return {
    type: REQUEST_ORGANIZATIONS
  };
}

export function receiveOrganizations(result) {
  return {
    type: RECEIVE_ORGANIZATIONS,
    result
  };
}

export function requestCurrentOrganization() {
  return {
    type: REQUEST_CURRENT_ORGANIZATION
  };
}

export function receiveCurrentOrganization(result) {
  return {
    type: RECEIVE_CURRENT_ORGANIZATION,
    result
  };
}

export function selectOrganization(result) {
  return {
    type: SELECT_ORGANIZATION,
    result
  };
}

export function cleanOrganizations() {
  return {
    type: CLEAN_ORGANIZATIONS
  };
}


